// extracted by mini-css-extract-plugin
module.exports = {"loader":"ColorContext_loader__hbvKL"};